/* eslint-disable default-case */
import BaseItemStudyApp from 'es6/controllers/apps/base-item-study-app';
import SelfAssessmentQuizDirectionPanel from 'es6/components/apps/settings/self-assessment-quiz-direction-panel';
import SelfAssessmentSequencer from 'es6/controllers/apps/self-assessment-sequencer';
import { QuizDirection } from 'es6/models/user-settings';
import { t } from 'es6/services/localization';

export default class SelfAssessmentApp extends BaseItemStudyApp {

  /**
   * Takes app settings from the app-launcher.
   */
  constructor(appSettings) {
    // Pass to BaseStudyApp for initialization.
    super('self_assessment', appSettings);
  }

  /**
   * Override the _checkpointTriggered() method.
   *
   * @returns {Boolean}
   */
  _checkpointTriggered() {
    return false;
  }

  /**
   * Creates the sequencer for self assessment.
   *
   * @returns {SelfAssessmentSequencer}
   */
  _createSequencer() {
    return new SelfAssessmentSequencer(this._sessionData, this._quizTimer);
  }

  /**
   * @override
   * @returns {Object}
   */
  _getDefaultQuizOptions() {
    return {
      quizDirection: QuizDirection.Forward,
    };
  }

  /**
   * Add settings panel that are specific to iKnow.
   *
   * @returns {Array}
   */
  _getSettingsPanels() {
    const panels = super._getSettingsPanels();

    // Add the self assessment quiz direction panel.
    panels.splice(1, 0, SelfAssessmentQuizDirectionPanel);

    return panels;
  }

  /**
   * Add study parameters that are specific to self asessment.
   *
   * @returns {Object}
   */
  _getStudyParameters() {
    const params = super._getStudyParameters();
    const quizOptions = this._userSettings.apps.selfAssessment.quizOptions;

    switch (quizOptions.quizDirection) {
      case QuizDirection.Forward:
        params.sequenceOptions.push('no_reverse_self_assessment');
        break;
      case QuizDirection.Reverse:
        params.sequenceOptions.push('no_forward_self_assessment');
        break;
    }

    return params;
  }

  /**
   * @override
   * @returns {String}
   */
  _getStartButtonLabel() {
    return t('memory-bank-screen.start-self-assessment');
  }
}
